<template>
  <b-row class="justify-content-md-center m-0 h-100">
    <b-col lg="8" cols="10">
      <b-row class="h-100">
        <b-col align-self="stretch" cols="12">
          <b-row align-h="between">
            <b-col cols="12">
              <div ref="text__title-review-lu" class="h5 display-4 mt-1 mb-4 font-weight-bold">
                Review micro-credential
              </div>
            </b-col>

            <b-col cols="12">
              <b-row align-h="between">
                <b-col cols="12" md="8" class="my-2">
                  <search-bar
                    ref="searchBar"
                    v-model="filter.name"
                    placeholder="Search micro-credentials here..."
                    @search="search"
                    @reset="onSearchReset"
                  />
                </b-col>
                <b-col cols="10" md="4" class="my-2">
                  <sort-or-filter
                    ref="sortOrFilter"
                    v-model="status"
                    @change="onStatusChanged"
                  ></sort-or-filter>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row align-v="stretch" align-h="center" style="height: 70vh">
            <b-col>
              <b-tabs
                v-model="$activeTab"
                class="mt-4"
                lazy
                pills
                nav-class="nav-line nav-line-alt"
                content-class="pt-5"
              >
                <b-tab lazy @click="onTabClicked(0)">
                  <template slot="title">
                    <span ref="title__new-lu" class="font-size-md active span__new-lu mr-2">{{
                      newReviewLUTabName
                    }}</span>

                    <div class="divider" />
                  </template>

                  <LearningUnitReviewList
                    ref="tab__new-lu"
                    :status="status"
                    :query-params="getQueryParams(false)"
                    :current-page.sync="currentPage"
                    class="tab__new-lu"
                  />
                  <!-- <TabNewDraft
                    v-if="!isLoading && activeTab === 'NEWDRAFT'"
                    :status="status"
                    class="tab__new-lu"
                    ref="tab__new-lu"
                  /> -->
                </b-tab>

                <b-tab v-if="status !== 'Published'" lazy @click="onTabClicked(1)">
                  <template slot="title">
                    <span
                      ref="title__new-requested-changes-lu"
                      class="font-size-md active span__new-requested-changes-lu mr-2"
                      >Requested changes</span
                    >

                    <div class="divider" />
                  </template>

                  <LearningUnitReviewList
                    ref="tab__requested-changes-lu"
                    :status="status"
                    :query-params="getQueryParams(true)"
                    class="tab__requested-changes-lu"
                    :current-page.sync="currentPage"
                  />

                  <!-- <TabRequestedChanges
                    v-if="!isLoading && activeTab === 'REQUESTEDCHANGES'"
                    :status="status"
                    class="tab__requested-changes-lu"
                    ref="tab__requested-changes-lu"
                  /> -->
                </b-tab>
              </b-tabs>

              <b-row v-show="isLoading" align-h="center">
                <b-spinner label="Loading..." variant="dark" class="p-4 m-3" />
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { SearchBar } from '../LearningUnit/components/index';
import SortOrFilter from './components/SortOrFilter';
import LearningUnitReviewList from '@/components/LearningUnit/LearningUnitReviewList';
// import TabNewDraft from "./components/TabNewDraft";
// import TabRequestedChanges from "./components/TabRequestedChanges";

const mapStatus = {
  draft: 'Draft',
  'submitted-for-publication': 'Submitted for publication',
  published: 'Published'
};

const mapSorting = {
  Draft: {
    is_published: false,
    required_review: false,
    _sort: 'created_at:desc'
  },
  'Submitted for publication': {
    required_review: true,
    is_published: false,
    _sort: 'submitted_review_at:asc'
  },
  Published: { is_published: true, _sort: 'published_at:desc' }
};

export default {
  components: {
    SortOrFilter,
    LearningUnitReviewList,
    SearchBar
  },

  data() {
    return {
      activeTab: this.$route.query.tab || 'new-submitted-for-publication',
      isLoading: false,
      status: mapStatus[this.$route.query.status] || 'Submitted for publication',
      currentPage: parseInt(this.$route.query.page) || 1,
      limit: parseInt(this.$route.query.limit) || 10,
      filter: {
        name: this.$route.query.name || []
      }
    };
  },

  computed: {
    nameTabs() {
      return this.getTabsByStatus(this.status);
    },

    $activeTab: {
      set(index) {
        this.activeTab = this.nameTabs[index];
      },

      get() {
        const indexTab = this.nameTabs.indexOf(this.activeTab);

        return Number(indexTab);
      }
    },

    newReviewLUTabName() {
      return this.status !== 'Published' ? `New ${this.status}` : 'Published';
    }
  },

  methods: {
    getQueryParams(requestChanges = false) {
      const sorting = { ...mapSorting[this.status] };

      if (this.status !== 'Published') {
        sorting.latest_request_changes_at_null = !requestChanges;

        if (requestChanges) {
          sorting._sort = `latest_request_changes_at:desc,${sorting._sort}`;
        }
      }

      const start = this.currentPage === 1 ? 0 : (this.currentPage - 1) * this.limit;

      return { ...sorting, ...this.filter, _start: start, _limit: this.limit };
    },

    getTabsByStatus(status) {
      let tabs = [];

      switch (status) {
        case mapStatus.draft:
          tabs = ['new-draft', 'requested-changes-draft'];
          break;

        case mapStatus.published:
          tabs = ['published'];
          break;

        default:
          tabs = ['new-submitted', 'requested-changes-submitted'];
          break;
      }

      return tabs;
    },

    onStatusChanged(status) {
      const statusEntry = Object.entries(mapStatus).find((entry) => {
        return entry[1] === status;
      });

      const newActiveTab = this.getTabsByStatus(status)[0];

      this.activeTab = newActiveTab;

      this.currentPage = 1;

      this.$router.replace({
        query: {
          ...this.$route.query,
          status: statusEntry[0],
          tab: newActiveTab,
          page: 1
        }
      });
    },

    onTabClicked(tabIndex) {
      const newActiveTab = this.nameTabs[tabIndex];

      if (this.activeTab === newActiveTab) return;

      this.currentPage = 1;

      this.$router.replace({
        query: {
          ...this.$route.query,
          tab: newActiveTab,
          page: 1
        }
      });
    },

    onSearchReset() {
      if (!this.filter.name.length) return;

      this.$set(this.filter, 'name', []);

      const query = { ...this.$route.query };

      // if route has query name, clear it and keep others query
      if (query.name) {
        delete query.name;
      }

      if (this.currentPage !== 1) {
        this.currentPage = 1;

        query.page = 1;
      }

      this.$router.replace({ query });
    },

    search(keywords) {
      this.currentPage = 1;

      this.$router.push({
        query: {
          ...this.$route.query,
          page: 1,
          name: keywords.length ? keywords : undefined
        }
      });
    }
  }
};
</script>
